import { Box, Typography } from '@mui/material'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import { ErrorMessage, Field } from 'formik'
import React, { useEffect } from 'react'
import PayrollAttachmentUpload from './PayrollAttachmentUpload'
import { downloadEmployeeDetails } from 'services/api/modules/payroll/payroll-config/bulkImportApi'
import { useQuery } from 'react-query'
import AdxButton from 'components/custom/AdxButton'
import { downloadResponseFile } from 'services/helper/fileDownload'

const ImportPayrollDataForm = ({ formikProps }) => {
  const { values, setFieldValue, handleSubmit, resetForm } = formikProps

  useEffect(() => {
    if (values.file) {
      handleSubmit()
    }
  }, [values.file])

  const { refetch } = useQuery('downloadBulk', () => downloadEmployeeDetails(), {
    enabled: false,
    onSuccess: (res) => {
      const reportFilename = `employee_details`
      downloadResponseFile(res, {
        fileName: `${reportFilename}.xlsx`,
        contentType: res.headers['content-type'],
        successMessage: 'Payroll employee details template downloaded.',
      })
    },
    onError: (err) => {
      console.log('err', err)
    },
  })
  const handleDownloadCsvFile = () => {
    refetch()
  }
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: '200px',
        gap: 2,
      }}
    >
      <Box sx={{ width: 1 }}>
        <Typography align="justify" variant="body2" color="light-gray-text.main">
          Import payroll details in csv file. Data that has error or already existed will not be
          uploaded.
        </Typography>
      </Box>
      <Box sx={{ width: 1 }}>
        <Typography variant="body2" color="dark-gray-text.main">
          Step 1
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
          <Typography color="light-gray-text.main">
            Download the CSV template and fill in the necessary details.
          </Typography>
        </Box>
      </Box>
      <Box sx={{ width: 1 }}>
        <AdxButton onClick={handleDownloadCsvFile} sx={{ width: 1 }}>
          Download CSV File
        </AdxButton>
      </Box>
      <Box sx={{ width: 1 }}>
        <Typography variant="body2" color="dark-gray-text.main">
          Step 2
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
          <Typography variant="body2" color="light-gray-text.main">
            Upload filled CSV File
          </Typography>
        </Box>
      </Box>
      <Box>
        <Field name="file" values={values.file} type="hidden" />
        <PayrollAttachmentUpload
          values={values}
          setFieldValue={setFieldValue}
          resetForm={resetForm}
          errorMessage={<ErrorMessage name="file" component={AdxErrorMessage} />}
        />
      </Box>
    </Box>
  )
}

export default ImportPayrollDataForm
